/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecipientsInfo
 */
export interface RecipientsInfo {
    /**
     * 
     * @type {number}
     * @memberof RecipientsInfo
     */
    recipientCount: number;
    /**
     * 
     * @type {number}
     * @memberof RecipientsInfo
     */
    printRecipientsCount: number;
}

/**
 * Check if a given object implements the RecipientsInfo interface.
 */
export function instanceOfRecipientsInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recipientCount" in value;
    isInstance = isInstance && "printRecipientsCount" in value;

    return isInstance;
}

export function RecipientsInfoFromJSON(json: any): RecipientsInfo {
    return RecipientsInfoFromJSONTyped(json, false);
}

export function RecipientsInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientsInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipientCount': json['recipientCount'],
        'printRecipientsCount': json['printRecipientsCount'],
    };
}

export function RecipientsInfoToJSON(value?: RecipientsInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipientCount': value.recipientCount,
        'printRecipientsCount': value.printRecipientsCount,
    };
}

